/* eslint-ignore */
// @ts-ignore
// @ts-nocheck
import React, { Component, useEffect } from 'react';
import TagManager from 'react-gtm-module';
import TourOverlay from 'newComponents/NewTour/TourOverlay';
import ChatTwillo from 'config/ChatTwillo';
import { useMediaQuery } from 'react-responsive';
import firebaseInitialize from './services/firebase';
import GlobalStyle from './styles/global';
import AppProviders from './config/AppProviders';
import Routes from './routes';

const App = (): JSX.Element => {
  const isMobile = useMediaQuery({ maxWidth: 620 });

  useEffect(() => {
    TagManager.initialize({
      gtmId: process.env.REACT_APP_GTM_ID,
    });
    firebaseInitialize.analytics();
  }, []);

  useEffect(() => {
    if (isMobile) return;
    const script = document.createElement('script');

    if (
      process.env.REACT_APP_ENV === 'build-prod' ||
      process.env.REACT_APP_ENV === 'prod'
    ) {
      script.innerHTML = `
        (function(p, u, r, pl, e) {
            pl = u.createElement("script");
            pl.id = "com-purple-metrics-script";
            pl.defer = 1;
            pl.src = r + "?v=" + Date.now();
            pl.type = "module";
            e = u.getElementsByTagName("head")[0];
            e.appendChild(pl);
            p._pm = p._pm || function() {
                (p._pm.q = p._pm.q || []).push(arguments)
            }
        })(window, document, "https://dashboard.purplemetrics.com.br/widget/js/widget.js");
        _pm("init", {
            companyId: "634118e1-c91a-46f0-a3b7-f78d874aaead",
            segmentId: 402,
            zIndex: 999999999,
            zIndexClosed: 999999999
        });
      `;
    } else {
      script.innerHTML = `
        (function(p, u, r, pl, e) {
            pl = u.createElement("script");
            pl.id = "com-purple-metrics-script";
            pl.defer = 1;
            pl.src = r + "?v=" + Date.now();
            pl.type = "module";
            e = u.getElementsByTagName("head")[0];
            e.appendChild(pl);
            p._pm = p._pm || function() {
                (p._pm.q = p._pm.q || []).push(arguments)
            }
        })(window, document, "https://dashboard.purplemetrics.com.br/widget/js/widget.js");
        _pm("init", {
            companyId: "634118e1-c91a-46f0-a3b7-f78d874aaead",
            segmentId: 402,
            zIndex: 999999999,
            zIndexClosed: 999999999,
            isDebug: true
        });
      `;
    }

    document.body.appendChild(script);

    return () => {
      document?.body?.removeChild(script);
    };
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      const triggerContainer = document.querySelector(
        '#com-purple-metrics .widget-container--desktop-rightBottom .trigger-container'
      );
      const startContainer = document.querySelector(
        '#com-purple-metrics .widget-container--desktop-rightBottom .start-container'
      );

      if (triggerContainer) {
        (triggerContainer as HTMLElement).style.setProperty(
          'top',
          '70%',
          'important'
        );
      }

      if (startContainer) {
        (startContainer as HTMLElement).style.setProperty(
          'top',
          '70%',
          'important'
        );
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });

    return () => {
      observer.disconnect();
    };
  }, []);

  return (
    <AppProviders>
      <Routes />
      <GlobalStyle />
      <ChatTwillo />
      <TourOverlay />
    </AppProviders>
  );
};

export default App;
